import React from "react";
import _ from 'lodash';
import {Formik, Field, FieldArray} from 'formik';
import {Ratio, Checkbox} from './Checkbox';
import {InputGroup, DatePicker, DateRangePicker} from "rsuite";
import moment from "moment";
import {Link} from "react-router-dom";

export class Cohorts extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-group row">
                <label className="col-2 col-form-label">
                    <Link to={`/cohorts`} >Cohorts (ctrl + click) </Link>
                    <i className="fa fa-info-circle" title="Активно только для выбранных когорт. Можно выбрать несколько. Объеденяются через логическое ИЛИ"></i>
                </label>
                <div className="col-5">
                    <Field component="select"
                           className="form-control cohorts"
                           name={this.props.name}
                           onChange={evt =>
                               this.props.setFieldValue(
                                   this.props.name,
                                   [].slice
                                       .call(evt.target.selectedOptions)
                                       .map(option => option.value)
                               )
                           }
                           multiple={true}>
                        { this.props.cohorts && this.props.cohorts.map(s => (
                            <option key={`${this.props.name}-${s._id}`} value={s._id}>
                                {s.title}
                            </option>
                        ))}
                    </Field>
                </div>
                <div className="col-5">
                    { this.props.cohorts && this.props.cohorts.map(s =>
                        <div>{this.props.cohortIds && this.props.cohortIds.includes(s._id) && <span>{s.title}</span>}</div>
                    )}
                </div>
            </div>
        );
    }
}